import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import React from 'react';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

interface Props {
  contentFormatter(label: string): string;
}
export const LandingSection: React.FC<Props> = ({ contentFormatter }) => {
  return (
    <UitkLayoutFlexItem
      style={{
        margin: 'unset',
        minHeight: '65vh',
        backgroundSize: 'cover',
        color: 'uds-token(color__neutral__white)',
        backgroundImage: `linear-gradient(0deg, rgba(31, 42, 55, 0.7), rgba(31, 42, 55, 0.9)),linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url("/docs/images/46dd6ef068a012473bd62e84f1f94625.jpeg")`,
      }}
    >
      <UitkLayoutFlex id="landing-section" direction="column" tag="section">
        <UitkLayoutGrid
          justifyContent="center"
          alignItems="center"
          columns={{ large: ['1fr', '1fr'], medium: ['1fr'] }}
          rows={['auto']}
          className="marketing-page-width"
        >
          <UitkLayoutGridItem>
            <Viewport>
              <ViewLarge>
                <UitkLayoutFlex direction="column" space="six">
                  <UitkSpacing margin={{ inlineend: 'twelve' }}>
                    <div>
                      <UitkText size={800} theme="inverse" spacing="six">
                        {contentFormatter('heroSection.heading')}
                      </UitkText>
                      <UitkText size={600} theme="inverse" spacing="six">
                        {contentFormatter('heroSection.subHeading')}
                      </UitkText>
                    </div>
                  </UitkSpacing>
                </UitkLayoutFlex>
              </ViewLarge>
              <ViewSmall>
                <UitkLayoutFlex direction="column" space="six" justifyContent="center">
                  <UitkText size={700} theme="inverse" spacing="six" align="center">
                    {contentFormatter('heroSection.heading')}
                  </UitkText>
                  <UitkText size={500} theme="inverse" spacing="six" align="center">
                    {contentFormatter('heroSection.subHeading')}
                  </UitkText>
                </UitkLayoutFlex>
              </ViewSmall>
            </Viewport>
          </UitkLayoutGridItem>
          <Viewport>
            <ViewLarge>
              <UitkLayoutGrid>
                <UitkFigure
                  imageFit="contain"
                  ratio={UitkFigureAspectRatioType.R4_3}
                  style={{
                    minHeight: '774px',
                    maxHeight: '774px',
                  }}
                >
                  <UitkImage src={`/docs/images/hero-image.png`} alt="heroSide" />
                </UitkFigure>
              </UitkLayoutGrid>
            </ViewLarge>
          </Viewport>
        </UitkLayoutGrid>
      </UitkLayoutFlex>
    </UitkLayoutFlexItem>
  );
};

LandingSection.displayName = 'LandingSection';
